import React from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { push } from "react-router-redux"
import { Route, Link, Switch } from "react-router-dom"
import {
  Slider,
  Select,
  Button as AButton,
  Col,
  Row,
  Icon as AIcon,
  Radio,
  Tooltip,
  Dropdown,
  Menu,
  Input
} from "antd"
import { MoreIcon, CheckedIcon } from "../core/icons"
import Line from "../core/Line"

import Card, { TitleCard, CardHeader } from "../core/Card"
import { getPlans, getInvoices } from "./actions"
import onMount from "../core/onMount"
import twix from "twix"
import moment from "moment"
import numeral from "numeral"

import Features from "./Features"
import Plans from "./Plans"
import FAQ from "./FAQ"
import ConnectedPlan from "./ConnectedPlan"
import PremiumFeatures from "./PremiumFeatures"

import TeamsUpsellPanel from "./TeamsUpsellPanel"
import GroupDiscountPanel from "./GroupDiscountPanel"
import PotentialCredits from "./PotentialCredits"
import "./Premium.css"
import styled from "styled-components"

const Invoices = props => (
  <Card showLoadingIcon={props.isFetchingInvoices}>
    <h1 style={{ marginTop: 0 }}>Invoices</h1>
    <HeaderRow align="space-between" type="flex">
      <Col sm={10}>Date</Col>
      <CenteredCol sm={5}>Status</CenteredCol>
      <CenteredCol sm={3} />
      <CenteredCol sm={4}>Download</CenteredCol>
    </HeaderRow>
    {props.data.map((invoice, i) => <Invoice {...invoice} key={i} />)}
    <div
      style={{ display: "flex", justifyContent: "flex-end", paddingTop: 20 }}
    >
      <AButton onClick={props.loadMore} disabled={!props.canLoadMore}>
        {props.canLoadMore ? "Load more" : "No more invoices to load"}
      </AButton>
    </div>
  </Card>
)

const HeaderRow = styled(Row)`
  margin: 0 -20px 10px;
  padding: 20px 40px;
  border: none;
  background-color: #dcf5f1;
  text-transform: uppercase;
`
const CenteredCol = styled(Col)`
  display: flex;
  justify-content: center;
`

const Invoice = ({
  date,
  paid,
  invoice_pdf,
  hosted_invoice_url,
  next_payment_attempt,
  billing,
  ...rest
}) => (
  <Row
    style={{ padding: 20, borderBottom: "solid 1px #e0e0e0" }}
    type="flex"
    justify="space-between"
    align="middle"
  >
    <Col sm={10}>{moment.unix(date).format("MMM DD, YYYY")}</Col>
    <CenteredCol sm={5}>
      {paid && (
        <a href={hosted_invoice_url} target="_blank">
          PAID
        </a>
      )}
      {!paid && (
        <Tooltip
          title={
            billing == "send_invoice"
              ? `Please click on 'Pay now' to pay the invoice`
              : `Next attempt date: ${next_payment_attempt}`
          }
        >
          UNPAID
        </Tooltip>
      )}
    </CenteredCol>
    <CenteredCol sm={3}>
      {!paid &&
        billing == "send_invoice" &&
        hosted_invoice_url && (
          <AButton>
            <a target="_blank" href={hosted_invoice_url}>
              Pay now
            </a>
          </AButton>
        )}
    </CenteredCol>
    <CenteredCol sm={4}>
      {invoice_pdf && (
        <a href={invoice_pdf}>
          <AIcon style={{ fontSize: "22px" }} type="download" />
        </a>
      )}
    </CenteredCol>
  </Row>
)

export default Invoices



// WEBPACK FOOTER //
// ./src/subscriptions/Invoices.jsx